module.exports = __webpack_public_path__ + "static/media/YM48_2.234b39fd.jpg";